import { useTranslate } from '@ur-solutions/react-hooks'
import { Module, ModuleOptionsValue } from '@/modules/companies'
import React from 'react'
import { isMobileOnly } from 'react-device-detect'
import styled from 'styled-components'
import { useModuleConfig } from '@/utils/hooks'
import { DynamicTableSettings } from '../components'
import {
  Header,
  InfoBox,
  OldSection,
  SectionHeader,
  SettingsWrapper,
} from '../components/common'
import { ModuleResponsibleUsers } from '../components/ModuleResponsibleUsers'
import { OptionToggle } from '../components/OptionToggle'

const Wrapper = styled.div`
  & > div + div {
    margin-top: 2rem;
  }
`

interface ActivitiesSettingsProps {}

export const ActivitiesSettings: React.FC<ActivitiesSettingsProps> = () => {
  const translations = useTranslate({
    info1: 'settings.info.driver-data-1',
    moduleOptions: 'settings.module-options',
    moduleSummary: 'settings.module-summary',
  })

  const { moduleOptions } = useModuleConfig(Module.ACTIVITIES)

  const activitiesModuleOptions = moduleOptions.filter(option =>
    [
      ModuleOptionsValue.ACTIVITIES_RECEIPT_FUNCTIONALITY,
      ModuleOptionsValue.ACTIVITIES_SIMPLE_DIET_OPTION,
      ModuleOptionsValue.ACTIVITIES_DIET_COMMENT_MANDATORY,
    ].includes(option.name as ModuleOptionsValue)
  )

  const activitiesSummaryOptions = moduleOptions.filter(option =>
    (option.name as ModuleOptionsValue).startsWith('ACTIVITIES_SUMMARY')
  )

  return (
    <SettingsWrapper
      grid={{
        flow: 'row',
      }}
    >
      <InfoBox initCollapsed={isMobileOnly}>
        <p>{translations.info1}</p>
      </InfoBox>
      <ModuleResponsibleUsers module={Module.ACTIVITIES} />
      <OldSection>
        <Header>
          <SectionHeader>{translations.moduleOptions}</SectionHeader>
        </Header>
        <Wrapper>
          {activitiesModuleOptions.map(option => (
            <OptionToggle key={option.id} option={option} />
          ))}
        </Wrapper>
      </OldSection>
      <OldSection>
        <Header>
          <SectionHeader>{translations.moduleSummary}</SectionHeader>
        </Header>
        <Wrapper>
          {activitiesSummaryOptions.map(option => (
            <OptionToggle key={option.id} option={option} />
          ))}
        </Wrapper>
      </OldSection>
      <OldSection>
        <DynamicTableSettings name="Activities" />
      </OldSection>
      <OldSection>
        <DynamicTableSettings name="Activities" forExport />
      </OldSection>
    </SettingsWrapper>
  )
}
